// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

// MUST be the first import. The lazy device/Web3Auth chunks pull deps
// (ledger-bitcoin, @ledgerhq/hw-transport-*) that reference the Node
// `Buffer` global at MODULE-EVAL time (e.g. ledger-bitcoin's psbtv2.js
// `const PSBT_MAGIC_BYTES = Buffer.from(...)`). Browsers have no global
// `Buffer`, so those module bodies throw `Cannot read properties of
// undefined (reading 'from'/'alloc')` the instant their chunk loads. A
// side-effect import inside those lazy chunks does NOT fix it: ESM hoists
// a chunk's static dep imports above any inlined polyfill statement, so
// the dep module-eval can run before the assignment. Front-loading here,
// in the entry, is airtight — the device chunks are only ever reached via
// runtime `import()`, strictly after this entry chunk has fully evaluated
// and set the global. The device stack stays out of the entry (this only
// pulls the small `buffer` package), so the entry remains device-free.
import './node-polyfills.js';
import { render } from 'preact';
import { App } from './app.js';
import { fetchSpaConfig } from './spa-config.js';

// COB-453: warm the runtime SPA config (one same-origin GET /api/spa-config)
// before the first paint, in parallel with the session bootstrap. Consumers all
// tolerate a cold cache, but priming here means a surface that reads the SV-1
// policy toggle — mounted seconds later, after sign-in and routing — renders its
// final treatment on the FIRST paint rather than flashing the default. Fire and
// forget: `fetchSpaConfig` never rejects (it resolves to SPA_CONFIG_FALLBACK).
void fetchSpaConfig();

render(<App />, document.getElementById('app')!);
